import React, { useEffect, useState } from "react";
import { Flex, Spin } from "antd";
import axiosInstance from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";

const ThingsToDoCardCountry = ({ heading = "Top things to do in Dubai" }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchThingsToDo = async () => {
      try {
        const res = await axiosInstance.get(
          `/product-details?filters[product_groups][name][$eq]=top_thing_to_do_in_countries&fields[0]=title&fields[1]=slug&fields[2]=final_price&fields[3]=old_price&fields[4]=save_price&populate[images][fields][0]=url&populate[sub_product][fields][0]=slug`
        );


        const items = res.data?.data || [];

        const formatted = items.map((item, index) => {
          const title =
            item?.title || item?.attributes?.title || "Untitled";

          const imageUrl =
            item?.images?.[0]?.url ||
            item?.attributes?.images?.data?.[0]?.attributes?.url ||
            "/placeholder.png";

          return {
            id: item?.id || index,
            title,
            img: `${process.env.REACT_APP_API_URL}${imageUrl}`,

            // fallback values
            rating: 4.9,
            reviews: 523,
            duration: "Best Seller",

            // ✅ required for navigation
            subProductSlug:
              item?.sub_product?.slug ||
              item?.attributes?.sub_product?.data?.attributes?.slug,

            slug:
              item?.slug || item?.attributes?.slug,
          };
        });

        setData(formatted);
      } catch (err) {
        console.error("Error fetching things to do:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchThingsToDo();
  }, []);

  const handleClick = (item) => {
    if (item.subProductSlug && item.slug) {
      navigate(`/${item.subProductSlug}/${item.slug}`);
    } else {
      console.warn("Missing slug data:", item);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-6">
        <Spin />
      </div>
    );
  }

  if (!data.length) {
    return (
      <div className="text-center text-gray-500 py-6">
        No data available
      </div>
    );
  }

  return (
    <div className="h-full px-4 pt-8 pb-6 bg-[linear-gradient(180deg,#FFFFFF_78.78%,#E5EBFF_100%)] border border-black/10 rounded-[15px]">
      <h3 className="font-semibold mb-6">{heading}</h3>

      <div className="space-y-4 max-h-[320px] overflow-y-auto pr-2">
        {data.map((item) => (
          <div
            key={item.id}
            className="flex gap-3 cursor-pointer hover:opacity-90 transition"
            onClick={() => handleClick(item)}
          >
            {/* Image */}
            <img
              src={item.img}
              alt={item.title}
              loading="lazy"
              className="w-full max-w-[6rem] h-16 object-cover rounded-xl"
            />

            {/* Content */}
            <div className="flex flex-col justify-between">
              <h3 className="!text-base font-semibold line-clamp-2">
                {item.title}
              </h3>

              <Flex align="center" className="text-danger font-medium">
                <div className="text-xl">★</div>
                <div className="text-xs ml-1">
                  {item.rating} ({item.reviews})
                </div>
              </Flex>

              <p className="text-primary font-medium text-xs">
                {item.duration}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThingsToDoCardCountry;